module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/emma-bonke-8afa25704e90fba547d55e2cf75ea764.jpg";